import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from './Icon';
import { Text } from './Text';
import './EmptyData.scss';
/**
 * @component EmptyData
 * @since 1.0.0
 */
export function EmptyData(props) {
    const { style, description, picto, title } = Object.assign({ style: 'normal', picto: 'triangle-exclamation' }, props);
    const className = classNames('empty-data', 'empty-data--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(Icon, { className: "empty-data-picto", value: picto }),
        React.createElement(Text, { className: "empty-data-title", value: title }),
        description && React.createElement(Text, { className: "empty-data-infos", value: description })));
}
